var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gaming-page-wrap"},[_c('div',{staticClass:"gaming-page"},[_c('GamingHeader',{on:{"update":_vm.changeFilter}}),_c(_vm.currentGame,{tag:"component",attrs:{"filters":_vm.filters}}),_c('GamingFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }